import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import * as Yup from "yup"
import { useNavigate } from 'react-router-dom'

// components
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner
} from '@coreui/react-pro'
import { Link } from 'react-router-dom'
import Cookies from 'js-cookie';

// icons
import CIcon from '@coreui/icons-react'
import { cilLockLocked, cilUser } from '@coreui/icons'

// helpers
import Axios from '../../../helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

const Login = () => {
  const navigate = useNavigate()
  const { showError } = useToastMessage();

  const token = Cookies.get("ut")

  const [isLoading, setIsLoading] = useState(false)
  const [isWrongEmailOrPassword, setIsWrongEmailOrPassword] = useState(false)
  const [wrongEmailOrPasswordMsg, setWrongEmailOrPasswordMsg] = useState('')
  const [isUserNotFound, setIsUserNotFound] = useState(false)
  const [userNotFoundMsg, setUserNotFoundMsg] = useState('')

  const formik = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().required("Please enter your email address."),
      password: Yup.string().required("Please enter your password.")
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSubmit(values)
      setSubmitting(false)
    },
  });

  const handleInputValue = (values) => {
    const payload = {}

    payload.email = values.email
    payload.password = values.password

    return payload
  }

  const handleLogin = (payload) => {
    setIsLoading(true)
    Axios({
      method: "post",
      url: '/api/sso/v1/users/login',
      data: payload
    })
      .then(({ data }) => {
        if (data) {
          let dataUser = {
            id: data?.id,
            profile: data?.profile,
            username: data?.username,
            role_id: data?.role_id[0],
            email: data?.email
          }
          localStorage.setItem("user", JSON.stringify(dataUser))
          navigate('/chat')
        }
      })
      .catch((err) => {
        console.error(err);
        if (err && err.response && err.response.data) {
          const { response: { data: { message } = {} } = {} } = err || {};
          if (message) {
            if (message === "wrong-email-or-password") {
              setIsWrongEmailOrPassword(true);
              setWrongEmailOrPasswordMsg('Wrong email or password')
            }
            if (message === 'user-not-found') {
              setIsUserNotFound(true);
              setUserNotFoundMsg('User not found')
            }
            if (message === 'user-not-verified') {
              showError('Please verify your email first!')
            }
            if (message === 'user-not-active') {
              showError('Your account is waiting for approval')
            }
          }
        }
      })
      .finally(() => setIsLoading(false))
  }

  const handleSubmit = (values) => {
    const inputPayload = handleInputValue(values)
    handleLogin(inputPayload)
  }

  useEffect(() => {
    if (token) {
      navigate('/chat')
    }
  }, [])

  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={6}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <CForm>
                    <h1>Login</h1>
                    <p className="text-medium-emphasis">Sign In To Your Account</p>
                    <CInputGroup className="mb-3">
                      <CInputGroupText>
                        <CIcon icon={cilUser} />
                      </CInputGroupText>
                      <CFormInput
                        type='email'
                        id='email'
                        name='email'
                        placeholder="Email Address"
                        value={formik.values.email}
                        onChange={(e) => formik.handleChange(e)}
                        invalid={formik.errors.email || isWrongEmailOrPassword || isUserNotFound}
                        feedbackInvalid={formik.errors.email ? formik.errors.email : isWrongEmailOrPassword ? wrongEmailOrPasswordMsg : isUserNotFound ? userNotFoundMsg : null}
                        autoComplete='off'
                      />
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInputGroupText>
                        <CIcon icon={cilLockLocked} />
                      </CInputGroupText>
                      <CFormInput
                        type="password"
                        placeholder="Password"
                        id='password'
                        name='password'
                        value={formik.values.password}
                        onChange={(e) => formik.handleChange(e)}
                        invalid={formik.errors.password || isWrongEmailOrPassword}
                        feedbackInvalid={formik.errors.password ? formik.errors.password : isWrongEmailOrPassword ? wrongEmailOrPasswordMsg : null}
                        autoComplete='off'
                      />
                    </CInputGroup>
                    <CRow>
                      <CCol xs={6}>
                        <CButton
                          color="dark"
                          className="px-4"
                          onClick={() => formik.handleSubmit()}
                        >
                          {isLoading && (
                            <CSpinner
                              className='me-2'
                              component="span"
                              color="light"
                              size="sm"
                              aria-hidden="true"
                            />
                          )}
                          Login
                        </CButton>
                      </CCol>
                      {/* <CCol xs={6} className="text-right">
                        <CButton color="link" className="px-0">
                          Forgot password?
                        </CButton>
                      </CCol> */}
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
              <CCard className="text-white bg-dark py-5" style={{ width: '44%' }}>
                <CCardBody className="text-center">
                  <div>
                    <h2>Sign up</h2>
                    <p>
                      Don't have an account?
                    </p>
                    <Link to="/register">
                      <CButton color="dark" className="mt-3" active tabIndex={-1}>
                        Register Now!
                      </CButton>
                    </Link>
                  </div>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
